export default "__VITE_ASSET__Cuy3fa2o__"